import { Container } from '@geberit/gdds';

import styles from './content-area-placeholder.module.scss';

interface ContentAreaPlaceholderProps {
  contentType: string;
  editType?: string;
  editArea?: string;
  previewId?: string;
}

export function ContentAreaPlaceholder({
  contentType,
  editType,
  editArea,
  previewId,
}: Readonly<ContentAreaPlaceholderProps>) {
  return (
    <Container maxContentWidth="90rem">
      <div
        className={styles.placeholder}
        data-edit-type={editType}
        data-edit-area={editArea}
        data-preview-id={previewId}
      >
        {contentType}
        <em>(empty)</em>
      </div>
    </Container>
  );
}
